import React from 'react';
import PropTypes from 'prop-types';
import { getMessages } from '../utils/translations';

function Options(props) {
  const {start, bg, language} = props;
  const messages = getMessages(language);

  return (
    <main className={"app " + bg}>
      <button
        type="button"
        className="start"
        onClick={start}
        aria-label={messages.startGame}
      />
    </main>
  )
};

Options.propTypes = {
  start: PropTypes.func.isRequired,
  bg: PropTypes.string.isRequired,
  language: PropTypes.string,
}

export default Options;
